





























import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {Tabs, TabPane} from 'element-ui'

@Component({
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  },
})
export default class TabsMenu extends Vue {
  /**
   * 메뉴 구성을 위한 prop, 탭에 표시되는 이름 값
   */
  @Prop() tabMenus: object[]
  /**
   * 페이지 이동에서 탭 유지를 위해 전달 받는 prop
   */
  @Prop({default: ''}) value: string

  /**
   * 탭 상단 기준 위치 prop
   */
  @Prop({default: 0, type: Number}) top: number

  /**
   * active 를 위한 탭 이름 값 (초기값 설정)
   */
  activeName: string = ''


  @Watch('value', {immediate: true})
  __value(val) {
    if(val) {
      this.activeName = val
    }
  }

  @Watch('activeName', {immediate: true})
  __activeName(val) {
    this.$emit('input', val)
  }

  onClickTab(e) {
    this.activeName = e.name
    this.$emit('tab-click', e.name)
  }

}
